<section class="login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-8">
        <div class="card-deck">
          <section class="card">
            <div class="card-img-top">
              <h3>{{ 'Log In' | translate }}</h3>
              <p>{{ 'You already have an account'| translate }}</p>
            </div>
            <div class="card-body">
              <app-login (eventLoggedIn)="onLoggedIn()"></app-login>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>
